import { getAchievementOrnamentUrl } from '../utils/arena/achievements';

// Renders an achievement-specific Viking ornament as a gold-tinted
// CSS mask. The source PNG's alpha channel becomes the silhouette;
// the wrapper's `background-color` is what actually paints, so the
// ornament always reads as gold on whatever surface it sits on.
// the same recipe VikingOrnament uses, just driven by the
// achievement id rather than the global ornament registry.
//
// Falls back to null when the id is missing so callers can render an
// alternative (e.g. the locked-medallion placeholder shield) without
// having to repeat the existence check.
export default function AchievementOrnamentIcon({
  achievementId,
  size = '100%',
  color = 'rgba(244, 215, 136, 0.95)',
  opacity = 1,
  className = '',
  style = {},
}) {
  const url = getAchievementOrnamentUrl(achievementId);
  if (!url) return null;

  return (
    <div
      aria-hidden="true"
      className={className}
      style={{
        width: size,
        height: size,
        // Mask sourced from the achievement PNG; the wrapper's
        // background colour is what actually renders inside the
        // masked silhouette.
        maskImage: `url("${url}")`,
        WebkitMaskImage: `url("${url}")`,
        maskRepeat: 'no-repeat',
        WebkitMaskRepeat: 'no-repeat',
        maskPosition: 'center',
        WebkitMaskPosition: 'center',
        maskSize: 'contain',
        WebkitMaskSize: 'contain',
        backgroundColor: color,
        // Embossed lift. A soft warm highlight + a recessed dark
        // shadow track the silhouette only (filter on a masked
        // element only follows masked-in pixels), giving the
        // ornament a struck-coin feel rather than a flat sticker.
        filter: 'drop-shadow(0 1px 0 rgba(255, 220, 140, 0.32)) drop-shadow(0 -1px 0 rgba(0, 0, 0, 0.7))',
        opacity,
        pointerEvents: 'none',
        ...style,
      }}
    />
  );
}
